export enum RequestFeedbackSubmitStatus {
  // FeedbackSubmitStatus: None
  None = 0,

  // FeedbackSubmitStatus: Success
  Success = 1,

  // FeedbackSubmitStatus: Error
  Error = 2,
}

export interface IComponentProps {
  requestId: string;
}

export enum FeedbackSurveyCategory {
  Knowledge = 1,
  Professionalism = 2,
  ResolutionTime = 3,
  FollowUp = 4,
  ProductQuality = 5,
  Other = 999,
}

export type SurveyCategoryKeys = keyof typeof FeedbackSurveyCategory;

export class SurveyCheckBoxCategories {
  public Knowledge = false;
  public Professionalism = false;
  public ResolutionTime = false;
  public FollowUp = false;
  public ProductQuality = false;
  public Other = false;
}

export class RequestFeedbackSchema {
  public Rating = 0;
  public RatingText = '';
  public RequestId = '';
  public RequestFeedbackSubmitStatus = RequestFeedbackSubmitStatus.None;
  public IsProcessing = false;
  public IssueResolved = true;
  public Comment = String();
  public IsFeedbackCategoriesVisible = false;
  public SurveyCheckBoxes: SurveyCheckBoxCategories = new SurveyCheckBoxCategories();
}

export enum RequestFeedbackStarRating {
  One = 1,
  Two,
  Three,
  Four,
  Five,
}
